import React from 'react';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import clsx from 'clsx';

import { mapPriorityToClassName } from '../../AdvancedSearch.utils';

import { useSelectedItemChipStyles } from './SelectedItemChip.styled';

export const SelectedItemChip = ({
  getOptionLabel,
  getPreferenceLabel,
  getPriorityLabel,
  isEditing,
  onEdit,
  onRemove,
  selectedItem
}) => {
  const classes = useSelectedItemChipStyles();
  const preferenceLabel =
    selectedItem.preference && getPreferenceLabel && getPreferenceLabel(selectedItem.preference);

  const handleEditClick = event => {
    onEdit(event, selectedItem.id);
  };

  const handleRemoveClick = () => {
    onRemove(selectedItem);
  };

  return (
    <Box className={classes.chipContainer}>
      <Box
        className={clsx(
          classes.itemChip,
          mapPriorityToClassName(selectedItem.priority),
          isEditing && 'popover-open'
        )}
      >
        <Box className={classes.chipContent}>
          <Typography variant="body2" className={classes.priorityText}>
            {getPriorityLabel(selectedItem.priority)}:
          </Typography>
          <Typography variant="body2" className={classes.itemText}>
            {getOptionLabel(selectedItem.item)} {preferenceLabel}
          </Typography>
        </Box>
        <Box className={clsx(classes.chipActions, isEditing && 'popover-open')}>
          <IconButton size="small" className={classes.actionButton} onClick={handleEditClick}>
            <MoreHorizIcon />
          </IconButton>
          <IconButton size="small" className={classes.actionButton} onClick={handleRemoveClick}>
            <CloseIcon />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
};
